// es6 Debouncer class

export default class TokenDebouncer {
    constructor() {
        console.log("new debouncer");
        this.debounceMap = {};
        this.debouncerTokenMap = {};
    }

    debounce(causeName, tokens, callback, delay) {
        if (this.debounceMap[causeName] != null) {
            clearTimeout(this.debounceMap[causeName]);
            this.debounceMap[causeName] = null;
        }


        this.debouncerTokenMap[causeName] = tokens;

        this.debounceMap[causeName] = setTimeout(() => {
            console.log("tokens to post: " + this.debouncerTokenMap[causeName] + " to cause: " + causeName + "");
            callback(causeName, this.debouncerTokenMap[causeName]);
            this.debouncerTokenMap[causeName] = 0;
        }, delay);
    }
}